export const informerandeTextRubrics = [
	{
		name: "Informerande text",
		grade: "åk3",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Minst fyra relevanta fakta 2) Källor anges muntligt 3) Tydliga exempel",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tre relevanta fakta 2) Några källor nämns 3) Exempel finns",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Två relevanta fakta 2) Minst en källa 3) Ett exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Relevanta fakta 2) Källor 3) Exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Mycket tydliga förklaringar 2) Passar mottagaren 3) Använder bilder eller jämförelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga förklaringar 2) Tänker på mottagaren 3) Några jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla förklaringar 2) Försöker förklara för andra",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Förklaringar 2) Tanke på mottagaren",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig början 2) Tre stycken 3) Tydligt slut",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) En början 2) Två-tre stycken 3) Ett slut",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Två stycken 2) Text som hänger ihop",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Stycken 2) Sammanhang",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sakligt språk 2) Några ämnesord 3) Mestadels rätt stavat",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Försöker vara saklig 2) Något ämnesord 3) Ofta rätt stavat",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkelt språk 2) Går att förstå",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Förståeligt språk 2) Läsbarhet",
					},
				],
			},
		],
	},
	{
		name: "Informerande text",
		grade: "åk4",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fem relevanta fakta 2) Källor anges tydligt 3) Bra exempel 4) Kontrollerar fakta",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fyra relevanta fakta 2) Källor nämns 3) Exempel finns",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tre relevanta fakta 2) Någon källa 3) Ett exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tillräckliga fakta 2) Källor 3) Exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Mycket tydliga förklaringar 2) Anpassar för mottagaren 3) Bra jämförelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga förklaringar 2) Tänker på mottagaren 3) Några jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla förklaringar 2) Viss mottagaranpassning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Förklaringar 2) Mottagaranpassning",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Bra början 2) Fyra stycken 3) Bra slut 4) Text som flyter",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig början 2) Tre stycken 3) Tydligt slut",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) En början 2) Två stycken 3) Ett slut",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur 2) Stycken 3) Avslut",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sakligt språk 2) Flera ämnesord 3) Få stavfel 4) Bindeord",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Oftast sakligt 2) Några ämnesord 3) Vissa bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker vara saklig 2) Något ämnesord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Saklighet 2) Ämnesord",
					},
				],
			},
		],
	},
	{
		name: "Informerande text",
		grade: "åk5",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sex relevanta fakta 2) Källor anges korrekt 3) Utförliga exempel 4) Kontrollerar fakta",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fem relevanta fakta 2) Källor nämns 3) Bra exempel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fyra relevanta fakta 2) Någon källa 3) Exempel finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tillräckliga fakta 2) Källor 3) Exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Utmärkta förklaringar 2) God mottagaranpassning 3) Utvecklade jämförelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Bra förklaringar 2) Tänker på mottagaren 3) Flera jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla förklaringar 2) Viss mottagaranpassning 3) Någon jämförelse",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Förklaringar 2) Mottagaranpassning 3) Jämförelser",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Intressant början 2) Fem stycken 3) Bra avslutning 4) God struktur",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Bra början 2) Fyra stycken 3) Tydlig avslutning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) En början 2) Tre stycken 3) En avslutning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig struktur 2) Stycken 3) Avslutning",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sakligt språk 2) Många ämnesord 3) Få fel 4) Bra bindeord",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Oftast sakligt 2) Flera ämnesord 3) Vissa bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ganska sakligt 2) Några ämnesord 3) Enkla bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Saklighet 2) Ämnesord 3) Bindeord",
					},
				],
			},
		],
	},

	{
		name: "Informerande text",
		grade: "åk6",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sju relevanta fakta 2) Källförteckning 3) Välutvecklade exempel 4) Källkritik",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Sex relevanta fakta 2) Källor anges 3) Utvecklade exempel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fem relevanta fakta 2) Några källor 3) Exempel finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tillräckliga fakta 2) Källor 3) Exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Mycket utvecklade förklaringar 2) Genomtänkt mottagaranpassning 3) Kreativa jämförelser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklade förklaringar 2) God mottagaranpassning 3) Bra jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande förklaringar 2) Viss mottagaranpassning 3) Några jämförelser",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga förklaringar 2) Mottagaranpassning 3) Jämförelser",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fångande inledning 2) Sex stycken 3) Genomtänkt avslutning 4) Tydlig röd tråd",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Bra inledning 2) Fem stycken 3) Bra avslutning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel inledning 2) Fyra stycken 3) Enkel avslutning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Inledning 2) Styckeindelning 3) Avslutning",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Konsekvent sakligt språk 2) Många ämnesord 3) Varierande bindeord 4) Korrekt språk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Sakligt språk 2) Flera ämnesord 3) Fungerande bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Mestadels sakligt 2) Några ämnesord 3) Enkla bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Saklighet 2) Ämnesord 3) Bindeord",
					},
				],
			},
		],
	},
	{
		name: "Informerande text",
		grade: "åk7",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Åtta relevanta fakta 2) Källförteckning med kritisk granskning 3) Djupgående exempel 4) Faktakontroll",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Sju relevanta fakta 2) Källor anges korrekt 3) Utvecklade exempel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Sex relevanta fakta 2) Källor finns 3) Grundläggande exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tillräckliga fakta 2) Källor 3) Exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Utmärkt förklaringsförmåga 2) Skicklig mottagaranpassning 3) Avancerade jämförelser 4) Pedagogiska exempel",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) God förklaringsförmåga 2) Tydlig mottagaranpassning 3) Utvecklade jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande förklaringar 2) Viss mottagaranpassning 3) Enkla jämförelser",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Förklaringar 2) Mottagaranpassning 3) Jämförelser",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektiv inledning 2) Sex-sju stycken 3) Genomtänkt avslutning 4) Logisk progression",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig inledning 2) Fem-sex stycken 3) Bra avslutning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel inledning 2) Fyra-fem stycken 3) Avslutning finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Inledning 2) Styckeindelning 3) Avslutning",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist och objektivt språk 2) Många ämnesspecifika begrepp 3) Avancerade bindeord 4) Korrekt språk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Sakligt språk 2) Flera ämnesbegrepp 3) Varierade bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Mestadels objektivt 2) Några ämnesbegrepp 3) Grundläggande bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Objektivt språk 2) Ämnesbegrepp 3) Bindeord",
					},
				],
			},
		],
	},
	{
		name: "Informerande text",
		grade: "åk8",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Nio relevanta fakta 2) Omfattande källkritisk granskning 3) Fördjupade exempel 4) Systematisk faktakontroll",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Åtta relevanta fakta 2) Källor värderas 3) Utvecklade exempel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Sju relevanta fakta 2) Källor anges 3) Grundläggande exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tillräckliga fakta 2) Källor 3) Exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Excellent pedagogisk framställning 2) Sofistikerad mottagaranpassning 3) Kreativa jämförelser 4) Klargörande exempel",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) God pedagogisk framställning 2) Tydlig mottagaranpassning 3) Utvecklade jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande framställning 2) Viss mottagaranpassning 3) Enkla jämförelser",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Pedagogisk framställning 2) Mottagaranpassning 3) Jämförelser",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Engagerande inledning 2) Sex-sju väldisponerade stycken 3) Effektfull avslutning 4) Tydlig progression",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Genomtänkt inledning 2) Fem-sex stycken 3) Genomarbetad avslutning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande inledning 2) Fyra-fem stycken 3) Tydlig avslutning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Inledning 2) Styckeindelning 3) Avslutning",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Exakt och objektivt språk 2) Omfattande ämnesbegrepp 3) Avancerade bindeord 4) Fullt korrekt språk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Sakligt språk 2) Flera ämnesbegrepp 3) Varierade bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Mestadels objektivt 2) Några ämnesbegrepp 3) Grundläggande bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Objektivt språk 2) Ämnesbegrepp 3) Bindeord",
					},
				],
			},
		],
	},

	{
		name: "Informerande text",
		grade: "åk9",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Omfattande, relevant faktaunderlag 2) Skicklig källkritisk granskning 3) Djupgående analys av ämnet 4) Tydliga exempel och förklaringar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Gott faktaunderlag 2) Källor värderas 3) God analys 4) Relevanta exempel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande fakta 2) Källor anges 3) Enkla exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tillräckliga fakta 2) Källor 3) Exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Excellent förklaringsförmåga 2) Skicklig målgruppsanpassning 3) Kreativa och klargörande jämförelser 4) Pedagogiska exempel",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) God förklaringsförmåga 2) Tydlig målgruppsanpassning 3) Utvecklade jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande förklaringar 2) Viss målgruppsanpassning 3) Enkla jämförelser",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga förklaringar 2) Målgruppsanpassning 3) Jämförelser",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Välformulerad introduktion som fångar läsaren 2) Sex-sju väldisponerade stycken 3) Sammanfattande avslutning 4) Logisk progression",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig introduktion 2) Fem-sex stycken 3) God avslutning 4) Genomtänkt upplägg",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel introduktion 2) Fyra stycken 3) Avslutning finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Introduktion 2) Styckeindelning 3) Avslutning",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist och objektivt språk 2) Avancerade ämnesspecifika begrepp 3) Tydliggörande bindeord 4) Fullt korrekt språkhantering",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Sakligt språk 2) Relevanta ämnesbegrepp 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Mestadels objektivt språk 2) Några ämnesbegrepp 3) Huvudsakligen korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Objektivt språk 2) Ämnesbegrepp 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Informerande text",
		grade: "firstRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tio relevanta fakta med fördjupning 2) Omfattande källkritisk analys 3) Välutvecklade exempel med analys 4) Systematisk faktakontroll med diskussion av tillförlitlighet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Nio relevanta fakta 2) Källor värderas och diskuteras 3) Utvecklade exempel med viss analys",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Åtta relevanta fakta 2) Källor anges korrekt 3) Grundläggande exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tillräckliga fakta 2) Korrekt källhantering 3) Relevanta exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Avancerad pedagogisk framställning 2) Genomtänkt mottagaranpassning med analys av målgrupp 3) Sofistikerade jämförelser 4) Problematiserande exempel",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Välutvecklad pedagogisk framställning 2) Tydlig mottagaranpassning 3) Utvecklade jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande pedagogisk framställning 2) Grundläggande mottagaranpassning 3) Relevanta jämförelser",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Pedagogisk framställning 2) Mottagaranpassning 3) Användbara jämförelser",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektfull inledning med tydligt syfte 2) Sju-åtta välstrukturerade stycken 3) Analyserande avslutning 4) Genomtänkt progression med röd tråd",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad inledning 2) Sex-sju stycken 3) Reflekterande avslutning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydlig inledning 2) Fem-sex stycken 3) Fungerande avslutning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fungerande inledning 2) Logisk styckeindelning 3) Sammanhängande avslutning",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist och nyanserat språk 2) Omfattande användning av ämnesspecifika begrepp 3) Akademiska bindeord 4) Stilistiskt säker framställning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Precist språk 2) God användning av ämnesbegrepp 3) Varierade bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Sakligt språk 2) Grundläggande ämnesbegrepp 3) Fungerande bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sakligt språk 2) Ämnesbegrepp 3) Fungerande bindeord",
					},
				],
			},
		],
	},
	{
		name: "Informerande text",
		grade: "secondRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tolv relevanta fakta med analys och problematisering 2) Akademisk källhantering med kritisk diskussion 3) Analytiska exempel med teoretisk koppling 4) Vetenskaplig faktakontroll",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tio relevanta fakta med viss analys 2) Utvecklad källhantering 3) Fördjupade exempel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Nio relevanta fakta 2) Grundläggande källhantering 3) Relevanta exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tillräcklig faktahantering 2) Akademisk källhantering 3) Användbara exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Vetenskaplig pedagogisk framställning 2) Strategisk mottagaranpassning med målgruppsanalys 3) Teoretiskt underbyggda jämförelser 4) Problematiserande perspektiv",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fördjupad pedagogisk framställning 2) Genomtänkt mottagaranpassning 3) Analytiska jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Utvecklad pedagogisk framställning 2) Tydlig mottagaranpassning 3) Relevanta jämförelser",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Pedagogisk medvetenhet 2) Mottagaranpassning 3) Fungerande jämförelser",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Analytisk inledning med teoretisk förankring 2) Åtta-nio väldisponerade stycken 3) Diskuterande avslutning 4) Akademisk textbindning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fördjupad inledning 2) Sju-åtta stycken 3) Analyserande avslutning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Utvecklad inledning 2) Sex-sju stycken 3) Utvecklad avslutning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fungerande struktur 2) Logisk styckeindelning 3) Sammanhängande avslutning",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Akademiskt och precist språk 2) Omfattande vetenskapliga begrepp 3) Avancerade akademiska bindeord 4) Vetenskaplig stilnivå",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Precist och objektivt språk 2) Fördjupade ämnesbegrepp 3) Akademiska bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Sakligt språk 2) Relevanta ämnesbegrepp 3) Utvecklade bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Akademiskt språk 2) Ämnesbegrepp 3) Fungerande bindeord",
					},
				],
			},
		],
	},
	{
		name: "Informerande text",
		grade: "thirdRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T09:38:30.000Z"),
		criteria: [
			{
				name: "Innehåll och faktahantering",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Femton relevanta fakta med teoretisk analys 2) Vetenskaplig källhantering med metoddiskussion 3) Forskningsbaserade exempel 4) Vetenskaplig validitet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tolv relevanta fakta med analys 2) Akademisk källhantering 3) Analytiska exempel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tio relevanta fakta 2) Utvecklad källhantering 3) Fördjupade exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Vetenskaplig faktahantering 2) Akademisk källhantering 3) Analytiska exempel",
					},
				],
			},
			{
				name: "Pedagogiskt upplägg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Forskningsbaserad pedagogisk framställning 2) Avancerad mottagaranpassning med teoretisk grund 3) Vetenskapliga jämförelser 4) Kritiskt perspektiv",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Akademisk pedagogisk framställning 2) Analytisk mottagaranpassning 3) Teoretiska jämförelser",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fördjupad pedagogisk framställning 2) Utvecklad mottagaranpassning 3) Analytiska jämförelser",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Akademisk framställning 2) Genomtänkt mottagaranpassning 3) Teoretiska jämförelser",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Forskningsbaserad inledning 2) Nio-tio väldisponerade stycken 3) Analytisk avslutning med teoretisk koppling 4) Vetenskaplig textbindning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Analytisk inledning 2) Åtta-nio stycken 3) Diskuterande avslutning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fördjupad inledning 2) Sju-åtta stycken 3) Analyserande avslutning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Akademisk struktur 2) Vetenskaplig disposition 3) Analytisk avslutning",
					},
				],
			},
			{
				name: "Språk och objektivitet",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Vetenskapligt språk 2) Omfattande forskningsbegrepp 3) Vetenskapliga bindeord 4) Forskningsetisk medvetenhet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Akademiskt språk 2) Teoretiska begrepp 3) Akademiska bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Utvecklat språk 2) Fördjupade ämnesbegrepp 3) Avancerade bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Vetenskapligt språk 2) Teoretiska begrepp 3) Akademiska bindeord",
					},
				],
			},
		],
	},
];
